import { AxiosResponse } from 'axios';
import AxiosInstanceBFF from './AxiosInstanceBFF';

export interface ISyncTemplatesArgs {
  botId: string;
}

export type SyncErrorResponse = {
  success?: boolean;
  errors?: {
    name: string;
    reason: string;
  }[];
};

export type SyncTemplatesResponse = string | SyncErrorResponse;

/**
 * Sync templates from the bot
 */
const syncTemplates = async (args: ISyncTemplatesArgs): Promise<AxiosResponse<SyncTemplatesResponse>> => {
  const { botId } = args;
  return AxiosInstanceBFF.get<SyncTemplatesResponse>(`v1/template/sync/${botId}`);
};

/**
 * Validates if the response is a success response
 */
export const isSuccessSyncTemplateResponse = (data: SyncTemplatesResponse): boolean => {
  const isStringResponse = typeof data === 'string';
  const isObjectResponse = typeof data === 'object' && data !== null && 'success' in data;
  return Boolean(isStringResponse || (isObjectResponse && data.success));
};

/**
 * Type guard to check if the response is an error response
 */
export const isSyncErrorResponse = (data: SyncTemplatesResponse): data is SyncErrorResponse =>
  Boolean(typeof data === 'object' && data !== null && 'success' in data && data.success === false);

export default syncTemplates;
